// @flow

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { log } from '../utils/jsUtils';

// TODO: once register works, replace this by env-specific vars.
const config = {
  apiKey: process.env.REACT_APP_FIREBASE_AUTH_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_AUTH_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_AUTH_PROJECTID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_AUTH_MESSAGING_SENDER_ID
};

const firebaseApp = initializeApp(config);
const auth = getAuth(firebaseApp);

// Add a token cache with expiration tracking
let tokenCache = {
  token: null,
  expiration: 0 // timestamp when the token expires
};

// Clear token cache - call on logout or user switch to prevent stale tokens
export const clearTokenCache = () => {
  tokenCache = {
    token: null,
    expiration: 0
  };
  log('[firebase] Token cache cleared');
};

// Buffer time (in milliseconds) before expiration to refresh the token
// 5 minutes buffer to be safe
const TOKEN_EXPIRY_BUFFER = 5 * 60 * 1000;

export const getNewIdToken = async (user) => {
  const now = Date.now();
  
  // If we have a cached token that's still valid (with buffer time)
  if (tokenCache.token && tokenCache.expiration > now + TOKEN_EXPIRY_BUFFER) {
    log('[firebase] using cached token');
    return tokenCache.token;
  }
  
  if (!user || typeof user.getIdToken !== 'function') {
    log('[firebase] No user provided to getNewIdToken');
    return null;
  }

  try {
    // Get a new token
    const idToken = await user.getIdToken(true);
    
    if (process.env.NODE_ENV === 'development') {
      log('[firebase] new idToken: ', idToken);
    }
    
    // Parse the JWT to get the expiration time
    const tokenParts = idToken.split('.');
    if (tokenParts.length === 3) {
      const payload = JSON.parse(atob(tokenParts[1]));
      if (payload.exp) {
        // exp is in seconds, convert to milliseconds
        tokenCache.expiration = payload.exp * 1000;
      } else {
        // If we can't get the expiration, set a default (1 hour from now)
        tokenCache.expiration = now + 60 * 60 * 1000;
      }
    }
    
    // Cache the token
    tokenCache.token = idToken;
    
    return idToken;
  } catch (error) {
    log('[firebase] Error getting new ID token:', error);
    throw error;
  }
};

// // we use setFreshIdToken to set asynchronously the newtoken in the state.
// const getNewIdToken = async(currentUser: Object): Promise<?string> => {
//   log('[firebase.getNewIdToken] currentUser: ', currentUser);
//   if (typeof currentUser !== 'undefined' && currentUser !== null) {
//     return currentUser.getIdToken()
//       .then(token => {
//         if (process.env.NODE_ENV === 'development') {
//           log('[firebase] new tokenId: ', token);
//         }
//         return token;
//       })
//       .catch(err => {
//         log('[firebase.getNewIdToken] error: ', err);
//         return err.message;
//       });
//   } else {
//     return new Promise((resolve, reject) => resolve(null));
//   }
// };

export {
  auth,
  onAuthStateChanged
};